<template>
  <div>
    <generate-cards :edit-info="editCardInfo" />
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="cardsLoading"
    >
      <b-card>
        <b-form @submit.prevent="fetchCards">

          <b-row>
            <b-col md="2">
              <b-button
                v-if="$can('write', 'voucher-cards')"
                class="mb-2"
                variant="primary"
                @click="displayModal('add')"
              >
                Generate Cards
              </b-button>
            </b-col>
            <b-col md="4">
              <b-form-input
                v-model="queryParams.serial_number"
                placeholder="Search by serial number"
              />
            </b-col>
            <b-col md="2">
              <b-button
                variant="primary"
                type="submit"
              >
                Search
              </b-button>
            </b-col>
          </b-row>
        </b-form>
        <b-table
          responsive
          :fields="columns"
          :items="cards"
          primary-key="id"
          show-empty
          empty-text="No matching cards found"
        >
          <template #cell(active)="data">
            {{ data.item.active ? 'Yes' : 'No' }}
          </template>
          <template #cell(charged)="data">
            {{ data.item.charged ? 'Yes' : 'No' }}
          </template>
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="$can('write', 'voucher-cards')"
                @click="displayModal('edit', data.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="totalCards"
          @new-per-page="queryParams.size = $event"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton, BDropdown, BDropdownItem, BForm, BFormInput, BRow, BCol,
} from 'bootstrap-vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'
import useVoucherCardList from '../hooks/useVoucherCardList'
import BasePagination from '@/UI/BasePagination.vue'
import GenerateCards from '../components/GenerateCardsForm.vue'
import vendorStore from '../../vendors/store'

export default {
  components: {
    BButton,
    BCard,
    BTable,
    BOverlay,
    BDropdown,
    BDropdownItem,
    GenerateCards,
    BasePagination,
    BForm,
    BFormInput,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    useRegisterStoreModule('voucherCards', store)
    useRegisterStoreModule('vendors', vendorStore)

    return {
      ...useVoucherCardList(ctx),
    }
  },
}
</script>

<style>

</style>
